export default __webpack_public_path__ + "static/media/push23.e3d6724e.gif";